export const environment = {
    apiUrl: 'https://lottery.apigateway.dev.solvextk.com',
    cognito: {
      userPoolId: 'us-east-2_FYwy5qAKy',
      userPoolClientId: '4lk03ekclji3bvbjafm749gm9r',
    }
};
